'use client';

import { ImageProcessingProvider } from '@/app/(image-rbg)/background-remover/context/ImageProcessingContext';

export default function TransparentBackgroundMakerLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return <ImageProcessingProvider>{children}</ImageProcessingProvider>;
}
